<div *ngIf="organization">
  <div class="row">
    <div class="col-4 py-5">
      <div class="split-header">
        <img src="{{organization.logo_storage_url}}" class="org-logo" />
        <h4>{{organization.name}}</h4>
        <a class="btn action-btn btn-cs component-flat" routerLink="edit">
          <i class="mdi mdi-lead-pencil"></i>
        </a>
      </div>
    </div>
  </div>

  <div class="row" *ngIf="organization">
    <div class="col-6 py-4">
      <div class="split-header">
        <h4>Users</h4>
        <a class="btn btn-primary text-white" routerLink="/users/new">
          Add New
        </a>
      </div>
    </div>
  </div>
  <div class="row">
    <table class="table">
      <thead>
        <tr>
          <th>Name</th>
          <th>Email</th>
          <th>Edit</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let user of organization.users">
          <td>{{user.firstName}} {{user.lastName}}</td>
          <td>{{user.email}}</td>
          <td>
            <a class="btn action-btn btn-cs component-flat" routerLink="/users/{{user.id}}">
              <i class="mdi mdi-lead-pencil"></i>
            </a>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
